import { createCustomEnum } from "./customEnum";

const AlignmentTypes = createCustomEnum({
	Left: {
		value: 0,
		name: "left",
		displayName: "Left",
	},
	Center: {
		value: 1,
		name: "center",
		displayName: "Center",
	},
	Right: {
		value: 2,
		name: "right",
		displayName: "Right",
	},
});

export default AlignmentTypes;
